module.exports = __webpack_public_path__ + "img/bg2.9cd0f06a.jpg";